module.exports = __webpack_public_path__ + "img/pregnant_woman.17fbea45.png";